<div class="flex flex-col">
    <div class="flex flex-wrap justify-between">
        <div class="flex flex-col">
            <h4 class="my-2">{{"quotation_history"|translate}}</h4>
            <small class="mb-3 text-xs">{{"view_past_quotations"|translate}}</small>
        </div>

        <div class="search-field">
            <form class="nosubmit">
                <input class="nosubmit" type="search" matInput (keyup)="applyFilter($event)" placeholder="Quotation ID" #input>
            </form>
        </div>
    </div>



      <div class="card-table overflow-auto" *ngIf="dataSource">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0 w-full">

          <ng-container matColumnDef="id">
            <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
            <td mat-cell class="id-td" *matCellDef="let row"> {{row.invoiceReference}} </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th class="table-th" mat-header-cell  *matHeaderCellDef mat-sort-header> {{"status"|translate}} </th>
            <td class="table-td" mat-cell  *matCellDef="let row"  class="text-center w-10 text-xxs font-extrabold" [style.color]="status[row.status]?.color"> {{status[row.status]?.text }} </td>
          </ng-container>

          <ng-container matColumnDef="company">
            <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"company"|translate}} </th>
            <td class="table-td" mat-cell *matCellDef="let row"> {{translateHelper.localize(row.companyData?.name)}} </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"date_created"|translate}} </th>
            <td class="table-td" mat-cell *matCellDef="let row" > {{row.quoteDate|date}} </td>
          </ng-container>

          <ng-container matColumnDef="lastUpdatedDate">
            <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"last_update_date"|translate}} </th>
            <td class="table-td" mat-cell *matCellDef="let row" > {{row.lastUpdated|date}} </td>
          </ng-container>

          <ng-container matColumnDef="total">
            <th class="table-th" mat-header-cell *matHeaderCellDef mat-sort-header> {{"total"|translate}} </th>
            <td class="table-td" mat-cell *matCellDef="let row" >
             <span *ngIf="row.status !== 'new'">{{row.total|currencyFormat}}</span>
             <span *ngIf="row.status === 'new'"> - </span></td>
          </ng-container>

          <tr  mat-header-row  *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row;  columns: displayedColumns;"[routerLink]="['/account/quotations',row._id]" class="cursor-pointer"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
      </div>
</div>



